import { httpRequest, BASE_URL } from "./api-shared"
import { ChangePassword, LogInResponse, userInfo, ConfirmAccount } from "./dataTypes";
import jwt_decode from "jwt-decode";
import { getUsersApi } from "./api-user";


const ACCOUNT_URL = "account"
export const STORAGE = {
  USER_NAME: 'bhs-user-name',
  USER_ROLES: 'bhs-user-roles',
  JWT_TOKEN: 'bhs-user-token',
  // REFRESH_TOKEN: 'refreshToken',
  SHIFT_START: 'shift-start-time',
  SHIFT_END: 'shift-end-time',
  SETUP_TIME: 'setup-time-per-cut',
}

export enum USER_ROLE {
  CUSTOMER = 'customer',
  DISTRIBUTOR = 'distributor',
  ADMINISTRATOR = 'admin',
}

const getUserRolesEnum = (): USER_ROLE[] => {
  const rolesString: string | null = localStorage.getItem(STORAGE.USER_ROLES);
  if (rolesString) {
    const r: string[] = rolesString.split(', ');
    let roles = r.map(role => role = USER_ROLE[role.toUpperCase()])
    return roles
  } else {
    return [];
  }
}

export const isAdminRole = (): boolean => {
  let roles: USER_ROLE[] = getUserRolesEnum();
  return roles.indexOf(USER_ROLE.ADMINISTRATOR) >= 0;
}

export const isDistributorRole = (): boolean => {
  let roles: USER_ROLE[] = getUserRolesEnum();
  return roles.indexOf(USER_ROLE.DISTRIBUTOR) >= 0;
}

export const logOut = () => {
  localStorage.clear();
}

export const isLoggedIn = () => {
  return getUserName() ? true : false;
}

export const getToken = () => {
  return localStorage.getItem(STORAGE.JWT_TOKEN);
}

export const getUserName = (): string => {
  let user = localStorage.getItem(STORAGE.USER_NAME) || '';
  return user;
}

export const getCurrentUser = () => {
  let email: string = getUserName();
  return getUsersApi().then(result => {
    if (result && email !== "") {
      let currentUser: userInfo =
        result[result.findIndex(e => e.email.toLowerCase() === email.toLowerCase())];
      if (currentUser !== null && currentUser.id !== "") {
        return currentUser;
      } else {
        return null;
      }
    } else {
      return null;
    }
  });
}

export const hasAdminRole = (): boolean => {
  let roles = localStorage.getItem(STORAGE.USER_ROLES) || '';
  if(roles.indexOf("admin")!==-1){
    return true;
  }
  else{
    return false;
  }
}

export const hasDistributorRole = (): boolean => {
  let roles = localStorage.getItem(STORAGE.USER_ROLES) || '';
  if(roles.indexOf("distributor")!==-1){
    return true;
  }
  else{
    return false;
  }
}

export const saveLoginData = (username: string, apiResult: LogInResponse) => {
  localStorage.setItem(STORAGE.USER_NAME, username);
  localStorage.setItem(STORAGE.JWT_TOKEN, apiResult.token);
  let decodedToken: any = jwt_decode(apiResult.token);
  let roles: string[] | string = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  if(typeof roles === 'string') {
    localStorage.setItem(STORAGE.USER_ROLES, roles)
  } else {
    try {
      // If the user only has 1 role, this will fail, so catch it below
      localStorage.setItem(STORAGE.USER_ROLES, roles.join(", "))
    } catch (error) { }
  }
}

export const login = (email: string, password: string): Promise<LogInResponse> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/login`,
    'post', { email: email, password: password }
  ).then(r => {
    if (r.success === true && r.data) {
      saveLoginData(email, r.data as LogInResponse);
      return r.data as LogInResponse;
    } else {
      console.log(`Error Logging In: ${r.error!.message}`)
      throw (r.error);
    }
  });
}

export const changePassword = (changePassword: ChangePassword): Promise<boolean> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/changePassword`,
    'post', changePassword
  ).then(result => {
    if (result.success === true) {
      return true;
    } else {
      console.log("Error changing password, " + result.error!.message);
      throw (result.error);
    }
  });
};

export const forgottenPasswordApi = (email:string): Promise<boolean> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/resetpassword?email=${email}`,
  'post').then(result => {
    if(result.success===true){
      return true;
    }else {
      console.log("Error resetting password, "+result.error!.message);
      //throw(result.error);
      return false;
    }
  })
}

export const addUserApi = (userInfo: userInfo):
  Promise<userInfo> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/add`,
    'post', userInfo
  ).then(r => {
    if (r.success === true && r.data) {
      return r.data as userInfo;
    } else {
      console.log("Error Adding User " + userInfo.email + ", cause: " + r.error!.message);
      throw (r.error);
    }
  });
};

export const editUserApi = (userInfo: userInfo): Promise<userInfo> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/edit`,
    'put', userInfo
  ).then(res => {
    if (res.success === true && res.data) {
      return res.data as userInfo;
    } else {
      console.log(res.error!.message);
      throw (res.error);
    }
  });
}

export const deleteUserApi = (userInfo: userInfo):
  Promise<userInfo> => {
  return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/delete`,
    'delete', userInfo
  ).then(r => {
    if (r.success === true && r.data) {
      return r.data as userInfo;
    } else {
      console.log("Error Deleting User " + userInfo.email + ", cause: " + r.error!.message);
      throw (r.error);
    }
  });
};


export const confirmAccount =
  (email: string, token: string, password: string, password2: string): Promise<LogInResponse> => {
    const dto: ConfirmAccount = {
      email: email,
      password: password,
      password2: password2,
      token: token
    };

    return httpRequest(`${BASE_URL}/${ACCOUNT_URL}/confirm`,
      'post',
      dto
    ).then(result => {
      if (result.success === true && result.data) {
        saveLoginData(email, result.data as LogInResponse);
        return result.data as LogInResponse;
      } else {
        console.log(result.error!.message);
        throw (result.error);
      }
    })
  }